import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=07a0a313&scoped=true&"
import script from "./collect.vue?vue&type=script&lang=js&"
export * from "./collect.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./collect.vue?vue&type=style&index=0&id=07a0a313&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "07a0a313",
  "3209bab6"
  
)

export default component.exports